import { createStore } from 'vuex';
import CookieStore from '@/Feature/CookieConsent/code/src/scripts/cookieconsent/CookieStore';

export const store = createStore({
    modules: {
        cookieStore: CookieStore,
    },
});
